var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 32.0393C32.9535 32.0393 35.3478 29.645 35.3478 26.6915C35.3478 23.7379 32.9535 21.3436 30 21.3436C27.0465 21.3436 24.6522 23.7379 24.6522 26.6915C24.6522 29.645 27.0465 32.0393 30 32.0393Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 37.648C45.8482 37.648 58.6957 32.7426 58.6957 26.6915C58.6957 20.6404 45.8482 15.735 30 15.735C14.1518 15.735 1.30435 20.6404 1.30435 26.6915C1.30435 32.7426 14.1518 37.648 30 37.648Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5114 32.1697C28.4355 45.8947 39.1074 54.5682 44.3478 51.5427C49.5883 48.5171 47.4127 34.9381 39.4886 21.2132C31.5645 7.48831 20.8926 -1.18524 15.6522 1.84032C10.4118 4.86588 12.5873 18.4448 20.5114 32.1697Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5114 21.2132C12.5873 34.9382 10.4118 48.5171 15.6522 51.5427C20.8926 54.5682 31.5645 45.8947 39.4886 32.1698C47.4127 18.4448 49.5883 4.8659 44.3478 1.84034C39.1074 -1.18522 28.4355 7.48833 20.5114 21.2132Z",
    stroke: "#61DAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 53.383,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.859431b7f61c216a3cde3bfcff334ed0.svg";
export { ForwardRef as ReactComponent };